// extracted by mini-css-extract-plugin
export default {"legend_header":"RulePicker_legend_header__jBvhK","legend_item":"RulePicker_legend_item__c0U36","legend_text":"RulePicker_legend_text__yVf-j"};